import reframe from 'nike-re-framejs';

const retry = (fn, counter = 5) => {
    if (counter && !fn()) {
        setTimeout(() => retry(fn, counter - 1), 250);
    }
};

const getLastScrollTop = () => reframe.appDb.peekValue().getIn(['responsive', 'lastScrollTop'], 0);

const getMainColumn = () => {
    const mainColumn = document.getElementsByClassName('layout-main-col');
    return mainColumn.length ? mainColumn[0] : null;
};

export const setScrollTop = (top = 0) => {
    const column = getMainColumn();
    if (!column) return null;
    column.scrollTop = top;
};

export const getScrollTop = () => {
    const column = getMainColumn();
    if (!column) return 0;
    return column.scrollTop;
};

export const scrollToLastTop = () => {
    const column = getMainColumn();
    if (!column) return null;
    const lastTop = getLastScrollTop();
    retry(() => {
        if (column.scrollHeight < lastTop) return false;
        column.scrollTop = lastTop;
        return true;
    });
};
